// @flow
import React from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';
import { turboCampaignEnd } from 'src/helpers/whitelist';

type Props = {
  active: boolean,
  isHideUpgradeTurbo: boolean,
  onCancel: () => void
};

export const KEY_BOOST_TURBO_MODAL = 'already-close-modal-boost-turbo';

type ComposedProps = Props & WithI18nProps;

const BannerOffer: React.FC<ComposedProps> = ({ i18n }) => {
  return (
    <div className="modal-former-upgrade-turbo__banner">
      <p className="modal-former-upgrade-turbo__banner__title">
        {i18n.translate('AdminHTML.Common.WarningFormer.Modal.banner_Text1', {
          t: <span className="modal-former-upgrade-turbo__banner__saving">$582!</span>
        })}
      </p>
      <p style={{ color: '#fff' }}>
        {i18n.translate('AdminHTML.Common.WarningFormer.Modal.banner_Text2', {
          date: (
            <span className="modal-former-upgrade-turbo__banner__saving-semibold">
              {turboCampaignEnd.format('MMM D')}
            </span>
          ),
          t1: (
            <span className="modal-former-upgrade-turbo__banner__saving-semibold">
              {i18n.translate('AdminHTML.Common.WarningFormer.Modal.banner_Text2_t1')}
            </span>
          ),
          t2: (
            <span className="modal-former-upgrade-turbo__banner__saving-semibold">
              {i18n.translate('AdminHTML.Common.WarningFormer.Modal.banner_Text2_t2')}
            </span>
          )
        })}
      </p>

      <div className="modal-former-upgrade-turbo__banner__advanced-features">
        <div className="advanced-features__item">
          <img
            src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.advancedSearch)}
            alt="advanced-search"
          />
          <p style={{ fontWeight: 500 }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.aiPowerSearch')}
          </p>
        </div>

        <div className="advanced-features__item">
          <img
            src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.recommendation)}
            alt="aiRecommendation"
          />
          <p style={{ fontWeight: 500 }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.aiRecommendation')}
          </p>
        </div>

        <div className="advanced-features__item">
          <img src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.analytics)} alt="analytics90" />
          <p style={{ fontWeight: 500 }}>
            {i18n.translate('AdminHTML.Common.WarningFormer.Modal.analytics90')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(BannerOffer);
